import React, { Component } from 'react';
import VideoList from './components/VideoList';
import Login from './components/Login';
import Cookies from 'js-cookie';
import { apiCall } from './utils/api';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import AdminPanel from './components/AdminPanel';

class App extends Component {
  state = {
    user: null,
    loading: true,
    showAdmin: false
  }

  componentDidMount() {
    this.checkAuth();
  }

  checkAuth = async () => {
    const token = Cookies.get('userToken');
    const userId = Cookies.get('userId');
    const isAdminCookie = Cookies.get('isAdmin'); // Récupère la chaîne 'true' ou 'false'
    
    if (token && userId) {
      try {
        // Tenter de vérifier le token et récupérer potentiellement plus d'infos utilisateur si nécessaire
        // Pour l'instant, on se fie aux cookies existants pour l'état initial
        // Une requête spécifique 'checkToken' côté PHP qui retourne user+is_admin serait idéale,
        // mais utilisons la requête 'pages' pour valider le token comme tu le fais.
        
        await apiCall('pages', { user_id: userId, token }); // Valide le token
        
        // Si l'appel réussit, le token est valide. Utilise l'info isAdmin du cookie.
        const isAdmin = isAdminCookie === 'true'; // Convertit la chaîne du cookie en booléen
        
        this.setState({ 
          user: { 
              id: userId, 
              token: token, // Utilise le token du cookie
              is_admin: isAdmin ? 1 : 0 // Assure que is_admin dans le state est 1 ou 0 (nombre)
          },
          loading: false,
          showAdmin: false // showAdmin est un booléen, défini si le cookie était 'true'
        });

      } catch (error) {
        // Si le token n'est pas valide ou autre erreur, on déconnecte
        console.error("Token validation failed:", error);
        Cookies.remove('userToken');
        Cookies.remove('userId');
        Cookies.remove('isAdmin');
        this.setState({ loading: false, user: null, showAdmin: false });
      }
    } else {
      // Pas de cookies, pas d'utilisateur connecté
      this.setState({ loading: false, user: null, showAdmin: false });
    }
  }

  handleLogin = (userFromApi) => {
    // userFromApi est l'objet reçu de l'API
    console.log("User logged in:", userFromApi);
    
    // Assure-toi que is_admin est un nombre 0 ou 1
    const isAdmin = parseInt(userFromApi.is_admin, 10) === 1; 

    // Stocker les informations dans les cookies
    Cookies.set('userToken', userFromApi.token);
    Cookies.set('userId', userFromApi.id);
    Cookies.set('isAdmin', isAdmin ? 'true' : 'false'); 

    // Mettre à jour le state
    this.setState({ 
        user: {
            id: userFromApi.id,
            token: userFromApi.token,
            is_admin: isAdmin ? 1 : 0 
        },
        showAdmin: false 
    });
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Chargement...</span>
          </div>
        </div>
      );
    }

    // Si l'utilisateur n'est PAS connecté, afficher le formulaire de connexion
    if (!this.state.user) {
        return (
            <div className="App">
                {/* Barre supérieure minimale pour l'écran de login */}
                <nav className="navbar navbar-dark bg-dark justify-content-between px-3">
                    <span className="navbar-brand mb-0 h1 text-light">Vidéos</span>
                </nav>
                <div className="container-fluid mt-3">
                    <Login onLogin={this.handleLogin} />
                </div>
            </div>
        );
    }

    // Si l'utilisateur EST connecté, afficher la barre complète et le contenu approprié
    return (
      <div className="App">
        {/* Barre supérieure complète si connecté */}
        <nav className="navbar navbar-dark bg-dark justify-content-between px-3">
          <span className="navbar-brand mb-0 h1 text-light">Vidéos</span>
          <div>
            {/* Bouton Admin (seulement si l'utilisateur dans le state est admin, format nombre 0 ou 1) */}
            {this.state.user.is_admin === 1 && (
              <button 
                className="btn btn-warning me-2" 
                onClick={() => this.setState({ showAdmin: !this.state.showAdmin })}
              >
                {this.state.showAdmin ? 'Retour aux vidéos' : 'Admin'}
              </button>
            )}
            {/* Bouton Déconnexion */}
            <button 
              className="btn btn-danger" 
              onClick={() => {
                Cookies.remove('userToken');
                Cookies.remove('userId');
                Cookies.remove('isAdmin');
                this.setState({ user: null, showAdmin: false });
              }}
            >
              Déconnexion
            </button>
          </div>
        </nav>

        <div>
           {this.state.showAdmin ? (
              <div className="container-fluid mt-3">
                <AdminPanel user={this.state.user} /> 
              </div>
           ) : (
             <VideoList user={this.state.user} />
           )}
        </div>
      </div>
    );
  }
}

export default App;